/**
 * EventCalendar JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class EventCalendar
 */
class EventCalendar {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get the calendars
        this.eventCalendar    = $( '#js-event-calendar' );
        this.calendarsbyMonth = this.eventCalendar.find( '.js-event-calendar-month' );
        this.currentMonth     = this.calendarsbyMonth.find( '#calendar-' + this.currentYear + '-' + this.currentMonth );
        this.monthsAmount     = this.calendarsbyMonth.length;
        this.secondLastMonth  = this.monthsAmount - 1;

        // Month buttons
        this.nextMonthButton     = this.eventCalendar.find( '.js-next-month-button' );
        this.previousMonthButton = this.eventCalendar.find( '.js-previous-month-button' );

        // Calendar events
        this.dayHasEventsButton = this.eventCalendar.find( '.js-day-has-events' );
        this.eventDay           = this.eventCalendar.find( '.js-events-day' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Change to the next month on clicking the button
        this.nextMonthButton.on( 'click', ( e ) => {

            // Get the data-month and data-year of the current month
            const currentMonthId = $( e.currentTarget ).closest( this.calendarsbyMonth ).data( 'month' ) ;
            const currentYearId  = $( e.currentTarget ).closest( this.calendarsbyMonth ).data( 'year' ) ;

            // A function to change the month
            this.changeMonth( currentMonthId, currentYearId, 'next' );
        });

        // Change to the previous month on clicking the button
        this.previousMonthButton.on( 'click', ( e ) => {

            // Get the data-month and data-year of the current month
            const currentMonthId = $( e.currentTarget ).closest( this.calendarsbyMonth ).data( 'month' ) ;
            const currentYearId  = $( e.currentTarget ).closest( this.calendarsbyMonth ).data( 'year' ) ;

            // A function to change the month
            this.changeMonth( currentMonthId, currentYearId, 'previous' );
        });

        // Show events for the selected date
        this.dayHasEventsButton.on( 'click', ( e ) => {

            // Get the date id (it matches the id of the day to show )
            const clickedDay = $( e.currentTarget ).data( 'date' );

            // Mark the current day as an active one
            $( e.currentTarget ).addClass( 'day-is-active' );

            // Remove the active class from other buttons
            this.dayHasEventsButton.not( e.currentTarget ).removeClass( 'day-is-active' );

            // Show the events for the clicked day
            this.showCurrentDayEvents( clickedDay );

        });
    }

    /**
     * Switch months in the calendar
     *
     * @param {int} currentMonth The current month number
     * @param {int} currentMonth The current year number
     * @param {string} whereTo Next or previous month
     */
    changeMonth( currentMonth, currentYear, whereTo ) {

        // Create empty variables to be filled later on.
        let monthToShow = '';
        let yearToShow = '';

        // Check if the user wants to see the next or the previous month.
        switch ( whereTo ) {

            // If the NEXT month button is clicked
            case 'next':

                // If current month is december, set the month to show to january and
                // add one to the year to show
                if ( currentMonth == 12 ) {
                    monthToShow = 1;
                    yearToShow = parseInt( currentYear ) + 1;
                } else {

                    // If current month is something else than december, add 1 month to the month to show
                    // and keep year to show as the current year.
                    monthToShow = parseInt( currentMonth ) + 1;
                    yearToShow = currentYear;
                }

            break;

            // If the PREVIOUS month button is clicked
            case 'previous':

                // If current month is january, set the month to show to december and
                // substact one from the year to show
                if ( currentMonth == 1 ) {
                    monthToShow = 12;
                    yearToShow = parseInt( currentYear ) - 1;
                } else {

                    // If current month is something else than january, substract 1 month from the month to show
                    // and keep year to show as the current year.
                    monthToShow = parseInt( currentMonth ) - 1;
                    yearToShow = currentYear;
                }

            break;

        }

        // Hide the current month and show the month the visitor wants to see
        this.eventCalendar.find( '#calendar-' + currentYear + '-' + currentMonth ).addClass( 'js-hidden' );

        // Show the month of the calendar the visitor wants to see
        this.eventCalendar.find( '#calendar-' + yearToShow + '-' + monthToShow ).removeClass( 'js-hidden' );

        // Control which buttons to show
        this.monthButtonController( yearToShow, monthToShow );

    }

    /**
     * Check if the next or the previous button needs to be hidden
     *
     * @param {int} yearToShow  The number of the year we want to show.
     * @param {int} monthToShow The number of the month we want to show.
     */
    monthButtonController( yearToShow, monthToShow ) {

        // Build the id for the calendar we are about so show, to match it to the first
        // and the last object of this.calendarsByMonth -item
        const currentMonthId = 'calendar-' + yearToShow + '-' + monthToShow;

        // Show the previous month button if the current month is not the first month of
        // all the calendars
        if ( this.calendarsbyMonth.first().attr( 'id' ) == currentMonthId ) {
                this.previousMonthButton.prop( 'disabled', true );
            } else {
                this.previousMonthButton.prop( 'disabled', false );
        }

        // Show the next month button if the current month is not the last month of
        // all the calendars
        if ( this.calendarsbyMonth.last().attr( 'id' ) == currentMonthId ) {
            this.nextMonthButton.prop( 'disabled', true );
        } else {
            this.nextMonthButton.prop( 'disabled', false );
        }


    }

    /**
     *
     * Show the events when a day is clicked
     *
     * @param {string} currentDay an id containing the day to show.
     */
    showCurrentDayEvents( currentDay ) {

        // Hide all the other days
        this.eventDay.addClass( 'js-hidden' );

        // Show the clicked day
        this.eventCalendar.find( '#' + currentDay ).removeClass( 'js-hidden' );
    }

    /**
     * Hide all but current month on page load, also disable the previous month button
     */
    hideUpcomingMonths() {

        // Get the current month and year - used to show the current month upon loading the page
        const currentDate  = new Date();

        // getMonth starts the count from 0, so we need to add 1 to get the actual
        // numerical representation of the current month
        const currentDay = currentDate.getDate();
        const currentMonth = currentDate.getMonth() + 1 ;
        const currentYear  = currentDate.getFullYear();

        // Build the id for current month. Dont add the # for id as the name of the id
        // needs to be used later on without the #
        const currentMonthId = 'calendar-' + currentYear + '-' + currentMonth;

        // Hide all the calendars except the first one to show
        this.calendarsbyMonth.not( '#' + currentMonthId ).addClass( 'js-hidden' );

        // Disable the previous month button if current month is the calendars first month
        if ( this.calendarsbyMonth.first().attr( 'id' ) == currentMonthId ) {
            this.previousMonthButton.prop( 'disabled', true );
        }

        // Hide all the events except the current day
        const currentDateForEvent = currentYear + '-' + currentMonth + '-' + currentDay;
        this.eventDay.not( '#' + currentDateForEvent ).addClass( 'js-hidden' );

        // Make the current date stand out as an active day
        this.calendarsbyMonth.find( '.date-' + currentDateForEvent ).addClass( 'day-is-active' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.hideUpcomingMonths();
    }
}

// Export the class reference.
module.exports = EventCalendar;



// WEBPACK FOOTER //
// ./assets/scripts/event-calendar.js